import { ParsedTelemetry, TelemetryFormat } from "../types"
import { parseSrtCues, srtSampleRate } from "./srt"

const gpsPattern = /GPS \((-?[\d.]+), (-?[\d.]+), (-?[\d.]+)\)/

const numberAfter = (payload: string, pattern: RegExp) => {
    const match = payload.match(pattern)
    return match ? Number(match[1]) : undefined
}

const parse = (text: string): ParsedTelemetry => {
    const cues = parseSrtCues(text)
    const events = cues.map((cue) => {
        const payload = cue.lines.find((line) => line.includes("GPS (")) ?? ""
        const gps = payload.match(gpsPattern)
        return {
            timestamp: cue.start,
            longitude: gps ? Number(gps[1]) : NaN,
            latitude: gps ? Number(gps[2]) : NaN,
            height: gps ? Number(gps[3]) : NaN,
            elevation: numberAfter(payload, /\bH (-?[\d.]+)m/),
            yaw: NaN,
            pitch: NaN,
            roll: NaN,
            horizontalSpeed: numberAfter(payload, /\bH\.S (-?[\d.]+)m\/s/),
            verticalSpeed: numberAfter(payload, /\bV\.S (-?[\d.]+)m\/s/),
        }
    })
    // the final embedded cue is often truncated mid-payload, so its event is unreliable
    events.pop()
    return { events, samplesPerSecond: srtSampleRate(cues) }
}

export const djiMini = {
    name: "dji-mini",
    matches: (prefix) => prefix.includes("GPS ("),
    parse,
} satisfies TelemetryFormat
